import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconRead16pxRegular = function IconRead16pxRegular(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 16 16",
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_7_1398)",
      fillRule: "evenodd",
      clipRule: "evenodd",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M8.45 2.366a.85.85 0 00-.9 0l-4.8 3a.85.85 0 00-.4.72V12.8c0 .47.38.85.85.85h9.6c.47 0 .85-.38.85-.85V6.087a.85.85 0 00-.4-.721l-4.8-3zM6.754 1.094a2.35 2.35 0 012.491 0l4.8 3a2.35 2.35 0 011.105 1.993V12.8a2.35 2.35 0 01-2.35 2.35H3.2A2.35 2.35 0 01.85 12.8V6.087c0-.81.417-1.564 1.104-1.993l4.8-3z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M1.376 6.784a.75.75 0 011.04-.208l4.669 3.112a1.65 1.65 0 001.83 0l4.669-3.112a.75.75 0 11.832 1.248l-4.669 3.113a3.15 3.15 0 01-3.494 0l-4.67-3.113a.75.75 0 01-.207-1.04z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_7_1398",
        children: /*#__PURE__*/_jsx("rect", {
          width: "16",
          height: "16"
        })
      })
    })]
  }));
};
export default IconRead16pxRegular;